module.exports = __webpack_public_path__ + "img/gsjj.3fda426a.jpg";